// extracted by mini-css-extract-plugin
module.exports = {"notAuthLang":"styles_notAuthLang__vd3B_"};